import React, { Component } from 'react';
 
class ModalDatosCuenta extends Component {

    constructor(props) {
        super(props);
    }


    render() {

        return (
            <div className='modalContainer'>
                <div className="modalDemandaOutXS">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => this.props.ocultarModal()} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title">{this.props.titulo}</h2>
                        </div>
                        <div className="modal-body"><p>{this.props.mensaje}</p></div>
                        <div className="modal-footer"> <div className="row">
                            <div className="col-xs-7">
                                <button type="button" className="btn btn-secondary" onClick={() => this.props.ocultarModal()} data-dismiss="modal">Cerrar</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalDatosCuenta;   